import React, { useState } from 'react';
import './Header.css';

import { Link } from "react-router-dom";
import { scroller } from "../../helpers/scroller";
import { goTop } from "../../helpers/goTop";

const logo = "/logo.ico";

const Header = () => {
  const [navOpen, setNavOpen] = useState(false);

  const handleClick = () => {
    setNavOpen(!navOpen);
  };

  const goHomeBtn = () => {
    goTop("behavior");
    if (navOpen === true) {
      setNavOpen(!navOpen);
    }
  };

  const goAboutUs = () => {
    scroller(".about-us-container", 100);
    if (navOpen === true) {
      setNavOpen(!navOpen);
    }
  };

  return (
    <>
      <header className={navOpen ? "header backdropOff" : "header backdropOn"}>
        <div className="container">
          <div className="burger-container">
            <Link to="/" className="logo-link">
              <img
                loading="lazy"
                src={logo}
                alt=""
                className="logoRes"
                onClick={goHomeBtn}
              />
            </Link>
            <div
              className={
                navOpen ? "burger burger-close" : "burger burger-branding"
              }
              onClick={handleClick}
            ></div>
          </div>
          <div className={navOpen ? "navbar-responsive open" : "navbar-responsive"}>
            <Link to="/" className="logo-link">
              <img
                loading="lazy"
                src={logo}
                alt=""
                className="logo"
                onClick={goHomeBtn}
              />
            </Link>
            <div className="navbar-items">
              <Link
                to="/"
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
                className="nav-links"
                onClick={goHomeBtn}
              >
                Home
              </Link>
              <Link
                to="/"
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
                className="nav-links"
                onClick={goAboutUs}
              >
                About Us
              </Link>
              <Link
                to="offer"
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
                className="nav-links"
                onClick={handleClick}
              >
                Offers
              </Link>
              <Link
                to="/menu"
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
                className="nav-links"
                onClick={handleClick}
              >
                Menu
              </Link>
              <Link
                to="shops"
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
                className="nav-links"
                onClick={handleClick}
              >
                Our Shops
              </Link>
              <Link
                to="gallary"
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
                className="nav-links"
                onClick={handleClick}
              >
                Gallary
              </Link>

            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
